import {
    getOffer,
    listOffers
} from './queries';
import {
    createOffer,
    deleteOffer,
    updateOffer,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {Offer} from "../types.ts";
import {generateClient} from "aws-amplify/api";
import {stripReadonlyFields} from '../../../utils/stripReadonlyFields';
import {
    notifyError,
    notifySuccess
} from "../../../components/ServiceNotifications.tsx";

import {ListRecordsQuery} from "../../../types";

export type ListOffers = {
    listOffers: { items: Offer[], nextToken: string }
}

export type GetOffer = {
    getOffer: Offer
}

export type CreateOffer = {
    createOffer: Offer
}

export type UpdateOffer = {
    updateOffer: Offer
}

export type DeleteOffer = {
    deleteOffer: string
}

const client = generateClient();


export const fetchRecords = async (query: ListRecordsQuery) => {
    try {
        const response = await client.graphql<GraphQLQuery<ListOffers>>({
            query: listOffers,
            variables: {...query},
        });
        return {
            items: response.data?.listOffers.items,
            nextToken: response.data?.listOffers.nextToken,
        };
    } catch (e) {
        notifyError(e);
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetOffer>>({
            query: getOffer,
            variables: {id: id},
        });
        return response.data?.getOffer;
    } catch (e) {
        notifyError(e);
    }
};

export const add = async (payload: object) => {
    try {
        const response = await client.graphql<GraphQLQuery<CreateOffer>>({
            query: createOffer,
            variables: {input: payload},
        });
        notifySuccess('Offer added successfully');
        return response.data?.createOffer;
    } catch (e) {
        notifyError(e);
    }
};

export const update = async (_id: string, record: Offer) => {
    const payload = stripReadonlyFields(record);
    try {
        const response = await client.graphql<GraphQLQuery<UpdateOffer>>({
            query: (updateOffer),
            variables: {input: payload},
        });
        notifySuccess('Offer updated successfully');
        return response.data?.updateOffer;
    } catch (e) {
        notifyError(e);
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteOffer>>({
            query: (deleteOffer),
            variables: {input: {id: id}},
        });
        notifySuccess('Offer deleted successfully');
        return response.data?.deleteOffer;
    } catch (e) {
        notifyError(e);
    }
};
